var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 271.5,
    height: 153.556,
    viewBox: "0 0 271.5 153.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.209,
    x2: 0.5,
    y2: 0.863,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#e5e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.321,
    y2: 3.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#878181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#959191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 1,
    x2: 0.321,
    y2: -2.002,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8179",
    "data-name": "Group 8179",
    transform: "translate(-537.232 -55.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10930",
    "data-name": "Path 10930",
    transform: "translate(539.232 62.509)",
    strokeLinecap: "round",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 268.998779296875 144.9906616210938 L -1.498743891716003 144.9906616210938 C -1.400113821029663 125.2824325561523 4.546158790588379 105.2911148071289 16.17900085449219 85.55986022949219 C 21.33003425598145 76.82279205322266 27.62529945373535 68.11142730712891 34.88993453979492 59.667724609375 C 41.52803421020508 51.95219421386719 49.01873397827148 44.40596008300781 57.15396499633789 37.2386589050293 C 64.57696533203125 30.69879150390625 72.49520111083984 24.50629234313965 80.68869781494141 18.83315849304199 C 88.22100067138672 13.61782550811768 95.79709625244141 8.966691970825195 103.2065658569336 5.008992195129395 C 110.074462890625 1.340559124946594 116.714599609375 -1.662940979003906 122.4091339111328 -3.676874160766602 C 127.95703125 -5.638907432556152 132.6347351074219 -6.676007747650146 135.9365386962891 -6.676007747650146 C 139.2333984375 -6.676007747650146 143.8450012207031 -5.639307498931885 149.2727966308594 -3.67800760269165 C 154.9140625 -1.639574289321899 161.2073364257812 1.282192468643188 167.9777984619141 5.006059169769287 C 175.1598052978516 8.956325531005859 182.4999389648438 13.60689258575439 189.7942962646484 18.82862663269043 C 197.7082061767578 24.49389266967773 205.3562316894531 30.68589210510254 212.5259704589844 37.23272705078125 C 220.3678741455078 44.39332580566406 227.5886688232422 51.93915939331055 233.98779296875 59.66069412231445 C 240.9812622070312 68.09935760498047 247.04150390625 76.81066131591797 252.0001068115234 85.55262756347656 C 263.1860656738281 105.2732696533203 268.9039611816406 125.2672805786133 268.998779296875 144.9906616210938 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 135.9365386962891 -6.176025390625 C 132.6908874511719 -6.176025390625 128.0708160400391 -5.148849487304688 122.5758514404297 -3.205490112304688 C 116.9046020507812 -1.199813842773438 110.2882843017578 1.793212890625 103.442138671875 5.449996948242188 C 96.04953002929688 9.398712158203125 88.48992919921875 14.03975677490234 80.97332763671875 19.24421691894531 C 72.79574584960938 24.90632629394531 64.89295959472656 31.08675384521484 57.4844970703125 37.61379241943359 C 49.36650085449219 44.76596832275391 41.89210510253906 52.29568481445312 35.26893615722656 59.99382781982422 C 28.02360534667969 68.41510772705078 21.74574279785156 77.10218811035156 16.60971069335938 85.81378936767578 C 5.12158203125 105.299560546875 -0.798736572265625 125.0350494384766 -0.994964599609375 144.4906463623047 L 268.4951477050781 144.4906463623047 C 268.3064575195312 125.0173797607422 262.613037109375 105.2763824462891 251.5652160644531 85.79928588867188 C 246.6210327148438 77.08279418945312 240.5776062011719 68.39582824707031 233.6028137207031 59.97972106933594 C 227.2183837890625 52.27597045898438 220.013671875 44.74697113037109 212.1887817382812 37.60193634033203 C 205.0336456298828 31.06843566894531 197.4011535644531 24.88893127441406 189.5032501220703 19.23518371582031 C 182.224853515625 14.02489471435547 174.901611328125 9.384933471679688 167.73681640625 5.44415283203125 C 161.0841369628906 1.7850341796875 154.6406402587891 -1.206741333007812 149.1028900146484 -3.207778930664062 C 143.7289733886719 -5.149642944335938 139.1761016845703 -6.176025390625 135.9365386962891 -6.176025390625 M 135.9365386962891 -7.176025390625 C 162.9894256591797 -7.176025390625 269.5 59.37375640869141 269.5 145.4906463623047 L -2 145.4906463623047 C -2 59.37375640869141 108.8836364746094 -7.176025390625 135.9365386962891 -7.176025390625 Z",
    stroke: "none",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M3519.791,142.965c42.12-9.814,105.406-15.732,167.934,0",
    transform: "translate(-2930.059 -34.66)",
    fill: "none",
    stroke: "#d4d3d3",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8163",
    "data-name": "Group 8163",
    transform: "translate(-15.716 47.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8161",
    "data-name": "Group 8161",
    transform: "translate(574.948 53.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10918",
    "data-name": "Path 10918",
    transform: "translate(0 69.702) rotate(-11)",
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.981,0H50.537L24.342,25.853H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.53838729858398 1.000001907348633 L 1.793788909912109 24.85260200500488 L 23.93169593811035 24.85260200500488 L 48.09991073608398 1.000001907348633 L 16.53838729858398 1.000001907348633 M 15.98091125488281 1.9073486328125e-06 L 50.5367431640625 1.9073486328125e-06 L 24.34206199645996 25.85260200500488 L 0 25.85260200500488 L 15.98091125488281 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10919",
    "data-name": "Path 10919",
    transform: "translate(13.111 34.636) rotate(-11)",
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.576,0,46.785,13.232,35.008,26.021H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.58966064453125 1.301780700683594 L 2.718055725097656 25.02088165283203 L 34.56898498535156 25.02088165283203 L 45.33013153076172 13.33561515808105 L 30.58966064453125 1.301780700683594 M 30.57635688781738 0 L 46.7847785949707 13.23224067687988 L 35.00751876831055 26.02088165283203 L -3.814697265625e-06 26.02088165283203 L 30.57635688781738 0 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10920",
    "data-name": "Path 10920",
    transform: "translate(45.687 7.516) rotate(-7)",
    fill: "url(#linear-gradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.674,0V19.323l-42.9,11.91L0,18.68Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.67406463623047 1.347745895385742 L 2.314083099365234 19.02406120300293 L 18.95332717895508 30.14610862731934 L 60.67406463623047 18.56236267089844 L 60.67406463623047 1.347745895385742 M 61.67406463623047 1.9073486328125e-06 L 61.67406463623047 19.32254028320312 L 18.77892303466797 31.23236083984375 L -7.62939453125e-06 18.68010139465332 L 61.67406463623047 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8162",
    "data-name": "Group 8162",
    transform: "translate(693.014 53.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_10918-2",
    "data-name": "Path 10918",
    transform: "translate(105.775 95.08) rotate(-169)",
    fill: "url(#linear-gradient-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.981,25.853H50.537L24.342,0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.09994506835938 24.85260200500488 L 23.93170928955078 1.000002861022949 L 1.793791770935059 1.000002861022949 L 16.53839302062988 24.85260200500488 L 48.09994506835938 24.85260200500488 M 50.53677368164062 25.85260200500488 L 15.98091506958008 25.85260200500488 L 4.933471700496739e-06 2.909850991272833e-06 L 24.34207534790039 2.909850991272833e-06 L 50.53677368164062 25.85260200500488 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10919-2",
    "data-name": "Path 10919",
    transform: "translate(92.631 60.179) rotate(-169)",
    fill: "url(#linear-gradient-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.576,26.021,46.785,12.789,35.008,0H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.58967399597168 24.71910095214844 L 45.33015823364258 12.68526172637939 L 34.56901168823242 1.000000834465027 L 2.718058109283447 1.000000834465027 L 30.58967399597168 24.71910095214844 M 30.57637023925781 26.02088165283203 L 7.415771392516035e-07 8.264159987447783e-07 L 35.00753021240234 8.264159987447783e-07 L 46.7848014831543 12.78864097595215 L 30.57637023925781 26.02088165283203 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_10920-2",
    "data-name": "Path 10920",
    transform: "translate(61.214 38.516) rotate(-173)",
    fill: "url(#linear-gradient-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.674,31.232V11.91L18.779,0,0,12.552Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.67410278320312 29.88461494445801 L 60.67410278320312 12.66999816894531 L 18.95334625244141 1.086251497268677 L 2.314090251922607 12.2082986831665 L 60.67410278320312 29.88461494445801 M 61.67410278320312 31.23235893249512 L 1.391601585964963e-06 12.55225849151611 L 18.7789421081543 -1.487426743551623e-06 L 61.67410278320312 11.90981864929199 L 61.67410278320312 31.23235893249512 Z",
    stroke: "none",
    fill: "rgba(148,145,145,0.39)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M5230.96,174.889l269.5-.121",
    transform: "translate(-4692.725 33)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose);
export default __webpack_public_path__ + "static/media/nose.c416a7215d5dff4fe99d7762eab1d3e3.svg";
export { ForwardRef as ReactComponent };